var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8 22.5H16C19 22.5 21 20.5 21 17.5V7.5C21 4.5 19 2.5 16 2.5H8C5 2.5 3 4.5 3 7.5V17.5C3 20.5 5 22.5 8 22.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.5007C14.37 5.7107 9.63998 5.7107 6.49998 8.5007C6.35998 8.6307 6.32998 8.8307 6.42998 8.9807L8.60998 12.4807C8.66998 12.5707 8.76998 12.6407 8.86998 12.6507C8.97998 12.6707 9.08998 12.6307 9.16998 12.5607C10.78 11.1307 13.2 11.1307 14.81 12.5607C14.88 12.6207 14.97 12.6507 15.06 12.6507C15.08 12.6507 15.1 12.6507 15.11 12.6507C15.22 12.6307 15.32 12.5707 15.37 12.4807L17.55 8.9807C17.67 8.8307 17.64 8.6307 17.5 8.5007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.9a26ceaa9d18e5ff407fa98de2d42f1b.svg";
export { ForwardRef as ReactComponent };